import { render, staticRenderFns } from "./GoodsPicker.vue?vue&type=template&id=653cdd30&scoped=true"
import script from "./GoodsPicker.vue?vue&type=script&lang=js"
export * from "./GoodsPicker.vue?vue&type=script&lang=js"
import style0 from "./GoodsPicker.vue?vue&type=style&index=0&id=653cdd30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653cdd30",
  null
  
)

export default component.exports